import { Box, Button, Icon, Link, Modal, Tooltip, Typography } from '@material-ui/core'
import React, { useState, useContext, useEffect } from 'react'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '@/custom/components/molecules/ProductCard/ProductCard.css'
import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { useHistory } from 'react-router-dom'
// import Popup from '@/product/components/organisms/Popup'
// import Timer from '../../../common/timer'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import BuyerContext from '@/product/context/buyer/buyerContext'
import AuthContext from '@/product/context/auth/authContext'
import PayContext from '@/product/context/payment/payContext'
import CreditContext from '@/product/context/credit/creditContext'
import { useTranslation } from 'react-i18next'
import ProductContext from '@/product/context/product/productContext'
import CommonContext from '@/product/context/common/commonContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import { handleRedirectInternal } from '@/custom/common/components'
import { currencyFormat } from '@/custom/common/components'
import { mapData } from '@/product/common/components'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import SignContext from '@/custom/context/signContext'
import CustomTooltip from '../../organisms/CustomTooltip/CustomTooltip'
import AlertContext from '@/product/context/alert/alertContext'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

const Bidding = (props) => {
    const buyerContext = useContext(BuyerContext)
    const authContext = useContext(AuthContext)
    const payContext = useContext(PayContext)
    const creditContext = useContext(CreditContext)
    const commonContext = useContext(CommonContext)
    const productContext = useContext(ProductContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { t } = useTranslation()

    const { searchValue, setBidHistoryValue } = commonContext
    const { getAllSearchProducts } = productContext

    const { payCartRosoom } = payContext
    const { addBidDeposit, responseStatus: responseStatusCredit } = creditContext
    const { allLocations, configVariables, allConfigurationVariables } =
        useContext(CustomCommonContext)
    const { handleLoginPopup } = useContext(SignContext)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)

    let { bidConfirm } = buyerContext
    const { user, isAuthenticated } = authContext
    const [product, setProduct] = useState()
    const history = useHistory()
    const [showMakeOffer, setShowMakeOffer] = useState(false)
    const [toggleDialog, setToggleDialog] = useState(false)
    const [isDefaultWprice, setDefaultWprice] = useState(0)
    const [toggleDialogDeposit, setToggleDialogDeposit] = useState(false)
    const [isHardOfferSelected, setHardOffer] = useState(false)
    const [cardCount, setCardCount] = useState(0)
    const [toggleDialogCard, setToggleDialogCard] = useState(false)
    const [toggleDialogMobileVerification, setToggleDialogMobileVerification] = useState(false)
    const [productLocation, setProductLocation] = useState({})

    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    const changeDialogStatusDeposit = () => {
        setToggleDialogDeposit(!toggleDialogDeposit)
    }

    const toggleHardOffer = () => {
        setHardOffer(!isHardOfferSelected)
        props.productHard(isHardOfferSelected)
    }

    const changeDialogStatusCard = () => {
        setToggleDialogCard(!toggleDialogCard)
    }

    const changeDialogStatusMobileVerification = () => {
        setToggleDialogMobileVerification(!toggleDialogMobileVerification)
    }

    useEffect(() => {
        if (get_all_card_details && get_all_card_details?.records?.length) {
            setCardCount(get_all_card_details.records.length)
        }
        return () => {
            setCardCount(0)
        }
    }, [get_all_card_details])
    function handleShowMake() {
        setShowMakeOffer(!showMakeOffer)
    }
    useEffect(() => {
        if (responseStatusCredit) {
            if (responseStatusCredit.from === 'addBidDeposit') {
                if (responseStatusCredit.status === 'success') {
                    setToggleDialogDeposit(false)
                    getAllSearchProducts(searchValue)
                }
            }
        }
    }, [responseStatusCredit])
    useEffect(() => {
        setProduct(props.data)
    }, [props.data])
    const [isMaxOpen, setIsMaxOpen] = useState(false)
    const handleOpenMax = () => {
        setIsMaxOpen(!isMaxOpen)
    }
    const pickStyle = {
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 2,
    }
    useEffect(() => {
        if (product) {
            if (allLocations?.length) {
                setProductLocation(
                    allLocations.filter((item) => item?.id === parseInt(product?.location))[0] ||
                        {},
                )
            }
            formik.setFieldValue('id', product.id)
            formik.setFieldValue('customBidData.location_id', parseInt(product?.location || 0))
            formikPayment.setFieldValue('cart_id', product.id)
        }
    }, [product])

    const validationArray = Yup.object({
        wsprice: Yup.number()
            .min(
                product ? product.next_bid : 0,
                `${'Min offer'} ${product ? currencyFormat(product.next_bid) : currencyFormat(0)}`,
            )
            .test('is-decimal', 'Cannot_be_a_decimal', (value) =>
                value ? typeof value === 'number' && value % 1 === 0 : true,
            )
            .required('Enter Offer Amount'),
    })
    const validationPayment = Yup.object({
        payment_method: Yup.string().required('Required'),
    })
    const removeAlpha = (evt) => {
        const re = /^[+-]?\d*(?:[.,]\d*)?$/
        if (re.test(evt.target.value)) {
            const regex = /^\d*$/
            if (regex.test(evt.target.value)) {
                formik.handleChange(evt)
            }
        }
    }
    const formik = useFormik({
        initialValues: {
            wsprice: '',
            id: 0,
            bidding_type: '',
            customBidData: { location_id: parseInt(product?.location || 0) },
            minimumReservePrice: true,
        },
        // validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.wsprice == '') {
                setAlert(`Please Enter Offer Amount`, 'error')
            } else {
                if (product.deposit && !product.bid_deposit_id) {
                    formik.setSubmitting(false)
                    setToggleDialogDeposit(true)
                } else if (toggleDialog) {
                    bidConfirm(values)
                    formik.setTouched({})
                    setDefaultWprice(formik.values.wsprice)
                    formik.values.wsprice = ''
                    setToggleDialog(false)
                } else {
                    if (user?.restocking_fee_status) {
                        setAlert(`Restocking fee due. Please see cart.`, 'error')
                    } else if (formik.values.wsprice >= product.next_bid) {
                        // formik.setSubmitting(false)
                        // setToggleDialog(true)

                        if (
                            true ||
                            (user?.phone &&
                                user?.phone_verified === 1 &&
                                user?.phone !== '+1' &&
                                user?.phone !== '1' &&
                                user?.phone !== '+' &&
                                user?.phone !== '' &&
                                user?.phone !== null &&
                                user?.phone !== '+10' &&
                                user?.phone !== '0')
                        ) {
                            formik.setSubmitting(false)
                            setToggleDialog(true)
                        } else {
                            setToggleDialogMobileVerification(true)
                        }

                        // if (cardCount) {
                        //     formik.setSubmitting(false)
                        //     setToggleDialog(true)
                        // } else {
                        //     setToggleDialogCard(true)
                        // }
                    } else {
                        setAlert(
                            `Minimum Offer is ${
                                product ? currencyFormat(product.next_bid) : currencyFormat(0)
                            }`,
                            'error',
                        )
                        // setAlert('Higher offer is already placed', 'error')
                    }
                }
            }
        },
    })

    useEffect(() => {
        formik.values.bidding_type = props.type
    }, [props.type])

    const formikPayment = useFormik({
        initialValues: {
            cart_id: 0,
            pay_type: 'bid_deposit',
            payment_method: '',
        },
        validationSchema: validationPayment,
        onSubmit: (values) => {
            formikPayment.setSubmitting(true)
            if (values.payment_method === 'wallet') {
                let formData = {
                    amount: product.deposit_amount,
                    product_id: values.cart_id,
                    credit_notes: `Bid Deposit - ${product.title}`,
                    credit_type: 'user',
                    type: 'projects',
                    creditor_id: user.id,
                }
                addBidDeposit(formData)
            } else if (values.payment_method === 'online') {
                let formData = {
                    cart_id: values.cart_id,
                    payment_object: {
                        type: 'projects',
                        amount: 0,
                    },
                    pay_type: values.pay_type,
                }
                payCartRosoom(formData)
            }
        },
    })
    const bidAmount1 = [
        {
            label: '',
            name: 'wsprice',
            type: 'number',
            id: props.id,
            tooltiptitle: `${allConfigurationVariables?.bid_tool_tip_title}`,
            // endAdornment: 'info',
            placeholder:
                product?.bidtopstatus === 'winner' && product.wprice
                    ? t(`${'@'} ${currencyFormat(product.wprice)}`)
                    : t(
                          `${'Min'} ${
                              product && product.next_bid
                                  ? currencyFormat(product.next_bid)
                                  : currencyFormat(0)
                          }`,
                      ),
            class:
                product?.bidtopstatus === 'winner' && product.wprice
                    ? 'newWinLabel'
                    : 'newLoseLabel',
            size: 'small',
            autoFocus: false,
            tooltiptitle: false,
            formik: formik,
            onChange: removeAlpha,
            disabled: props?.disabled,
        },

        // {
        //     helperText:
        //         props.helpText &&
        //         (product && product.bidhistory.length > 0
        //             ? 'Enter ' + currencyFormat(product.next_bid) + ' or more'
        //             : product && 'Minimum_Bid' + ' ' + currencyFormat(product.next_bid)),
        //     label: 'Enter Bid Amt',
        //     name: 'wsprice',
        //     type: 'number',
        //     placeholder: `${'Min Bid'} ${
        //         product && product.next_bid ? currencyFormat(product.next_bid) : currencyFormat(0)
        //     }`,
        //     class: '',
        //     size: 'small',
        //     disabled: canBid ? false : true,
        //     autoFocus: false,
        //     formik: formik,
        //     onChange: removeAlpha,
        // },
    ]
    const bidAmount2 = [
        {
            label: '',
            name: 'wsprice',
            type: 'number',
            id: props.id,
            tooltiptitle: `${allConfigurationVariables?.bid_tool_tip_title}`,
            // endAdornment: 'info',
            placeholder:
                product?.bidtopstatus === 'winner' && product.wprice
                    ? t(`${'@'} ${currencyFormat(product.wprice)}`)
                    : t(
                          `${'Min'} ${
                              product && product.next_bid
                                  ? currencyFormat(product.next_bid)
                                  : currencyFormat(0)
                          }`,
                      ),
            class:
                product?.bidtopstatus === 'winner' && product.wprice
                    ? 'newWinLabel'
                    : 'newLoseLabel',
            size: 'small',
            autoFocus: false,
            tooltiptitle: false,
            formik: formik,
            onChange: removeAlpha,
            disabled: props?.disabled,
        },

        // {
        //     helperText:
        //         props.helpText &&
        //         (product && product.bidhistory.length > 0
        //             ? 'Enter ' + currencyFormat(product.next_bid) + ' or more'
        //             : product && 'Minimum_Bid' + ' ' + currencyFormat(product.next_bid)),
        //     label: 'Enter Bid Amt',
        //     name: 'wsprice',
        //     type: 'number',
        //     placeholder: `${'Min Bid'} ${
        //         product && product.next_bid ? currencyFormat(product.next_bid) : currencyFormat(0)
        //     }`,
        //     class: '',
        //     size: 'small',
        //     disabled: canBid ? false : true,
        //     autoFocus: false,
        //     formik: formik,
        //     onChange: removeAlpha,
        // },
    ]
    const modeOfPayment = [
        {
            label: t('Select mode of payment'),
            placeholder: t('Select mode of payment'),
            type: 'select',
            class: 'col-12',
            options: [
                { value: 'online', show: t('online') },
                { value: 'wallet', show: t('wallet') },
            ],
            name: 'payment_method',
            formik: formikPayment,
        },
    ]

    return (
        <>
            {product ? (
                <>
                    <>
                        {product.market_status === 'open' ? (
                            <>
                                {props.mobileViewLayout ? (
                                    <>
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="biddingCnt d-flex align-items-center hard-bid">
                                                {props.type === 'hard'
                                                    ? isHardOfferSelected &&
                                                      Object.values(mapData(bidAmount1))
                                                    : Object.values(mapData(bidAmount2))}
                                                {props.type !== 'hard' ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={'Max Offer'}
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={'Max Offer'}
                                                                btnSize="small"
                                                                onClick={handleLoginPopup}
                                                                disabled={props?.disabled}
                                                            />
                                                        )}

                                                        <img
                                                            className="infoIcon"
                                                            src="/assets/svg/infoIcon.svg"
                                                            onClick={handleOpenMax}
                                                        />
                                                    </>
                                                ) : isHardOfferSelected ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                onClick={handleLoginPopup}
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        )}
                                                    </>
                                                ) : null}
                                            </div>
                                        </form>
                                        <div
                                            className={`d-flex w-100 mb-md-5 mb-sm-2 position-relative justify-content-between hardOfferHandlerLst`}
                                            style={{ gap: '8px' }}
                                        >
                                            <div className="arrowClose">
                                                {isHardOfferSelected ? (
                                                    <Button
                                                        variant="Text"
                                                        style={{ textTransform: 'none' }}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0"
                                                    >
                                                        {<ExpandLessIcon />} hard offer
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="Text"
                                                        style={{
                                                            textTransform: 'none',
                                                            width: '100%',
                                                        }}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0 mt-0 newBtClass"
                                                    >
                                                        {<ExpandMoreIcon />} hard offer
                                                    </Button>
                                                )}
                                            </div>
                                            {product.auction ? (
                                                <>
                                                    {isAuthenticated ? (
                                                        <Button
                                                            id="view_bid_history"
                                                            className="pvBidHistBtn"
                                                            onClick={() =>
                                                                setBidHistoryValue(product.id)
                                                            }
                                                        >
                                                            <img
                                                                className="mr-2"
                                                                src="/assets/svg/Gavel.svg"
                                                            />{' '}
                                                            {t('offer history')}
                                                        </Button>
                                                    ) : null}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        className={`d-flex w-100 position-relative MPddAdjst ${
                                            isHardOfferSelected && props.cardType === 'GridCard'
                                                ? 'flex-column-reverse align-items-start f'
                                                : 'flex-column-reverse align-items-end'
                                        }`}
                                        style={{ gap: '8px', marginBottom: '0px' }}
                                    >
                                        {isHardOfferSelected ? (
                                            <div className="arrowClose">
                                                <Button
                                                    variant="Text"
                                                    style={{ textTransform: 'none' }}
                                                    onClick={toggleHardOffer}
                                                    className="pl-0"
                                                >
                                                    {<ExpandLessIcon />} hard offer
                                                </Button>
                                            </div>
                                        ) : null}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="biddingCnt d-flex align-items-center hard-bid">
                                                {props.type === 'hard'
                                                    ? isHardOfferSelected &&
                                                      Object.values(mapData(bidAmount1))
                                                    : Object.values(mapData(bidAmount2))}
                                                {props.type !== 'hard' ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={'Max Offer'}
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={'Max Offer'}
                                                                btnSize="small"
                                                                onClick={handleLoginPopup}
                                                                disabled={props?.disabled}
                                                            />
                                                        )}

                                                        <img
                                                            className="infoIcon"
                                                            src="/assets/svg/infoIcon.svg"
                                                            onClick={handleOpenMax}
                                                        />
                                                    </>
                                                ) : isHardOfferSelected ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                onClick={handleLoginPopup}
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Button
                                                        variant="Text"
                                                        style={{
                                                            textTransform: 'none',
                                                            width: '100%',
                                                        }}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0 mt-0 pb-0 newBtClass"
                                                    >
                                                        {<ExpandMoreIcon />} hard offer
                                                    </Button>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                )}
                            </>
                        ) : product.market_status === 'sold' ? (
                            <>
                                {props.mobileViewLayout ? (
                                    <>
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="biddingCnt d-flex align-items-center hard-bid">
                                                {props.type === 'hard'
                                                    ? isHardOfferSelected &&
                                                      Object.values(mapData(bidAmount1))
                                                    : Object.values(mapData(bidAmount2))}
                                                {props.type !== 'hard' ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={'Max Offer'}
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={'Max Offer'}
                                                                btnSize="small"
                                                                onClick={handleLoginPopup}
                                                                disabled={props?.disabled}
                                                            />
                                                        )}

                                                        <img
                                                            className="infoIcon"
                                                            src="/assets/svg/infoIcon.svg"
                                                            onClick={handleOpenMax}
                                                        />
                                                    </>
                                                ) : isHardOfferSelected ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                onClick={handleLoginPopup}
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        )}
                                                    </>
                                                ) : null}
                                            </div>
                                        </form>
                                        <div
                                            className={`d-flex w-100 mb-md-5 mb-sm-2 position-relative justify-content-between hardOfferHandlerLst`}
                                            style={{ gap: '8px' }}
                                        >
                                            <div className="arrowClose">
                                                {isHardOfferSelected ? (
                                                    <Button
                                                        variant="Text"
                                                        style={{ textTransform: 'none' }}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0"
                                                        // disabled={props.disabled}
                                                    >
                                                        {<ExpandLessIcon />} hard offer
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="Text"
                                                        style={{
                                                            textTransform: 'none',
                                                            width: '100%',
                                                        }}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0 mt-0 newBtClass"
                                                        // disabled={props.disabled}
                                                    >
                                                        {<ExpandMoreIcon />} hard offer
                                                    </Button>
                                                )}
                                            </div>
                                            {product.auction ? (
                                                <Button
                                                    id="view_bid_history"
                                                    className="pvBidHistBtn"
                                                    onClick={() => setBidHistoryValue(product.id)}
                                                    // disabled={props.disabled}
                                                >
                                                    <img
                                                        className="mr-2"
                                                        src="/assets/svg/Gavel.svg"
                                                    />{' '}
                                                    {t('offer history')}
                                                </Button>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        className={`d-flex w-100 pt-2 position-relative MPddAdjst ${
                                            isHardOfferSelected && props.cardType === 'GridCard'
                                                ? 'flex-column-reverse align-items-start f'
                                                : 'flex-column-reverse align-items-end'
                                        }`}
                                        style={{ gap: '8px' }}
                                    >
                                        {isHardOfferSelected ? (
                                            <div className="arrowClose">
                                                <Button
                                                    variant="Text"
                                                    style={{ textTransform: 'none' }}
                                                    onClick={toggleHardOffer}
                                                    className="pl-0"
                                                    // disabled={props?.disabled}
                                                >
                                                    {<ExpandLessIcon />} hard offer
                                                </Button>
                                            </div>
                                        ) : null}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="biddingCnt d-flex align-items-center hard-bid">
                                                {props.type === 'hard'
                                                    ? isHardOfferSelected &&
                                                      Object.values(mapData(bidAmount1))
                                                    : Object.values(mapData(bidAmount2))}
                                                {props.type !== 'hard' ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={'Max Offer'}
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={props?.disabled}
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={'Max Offer'}
                                                                btnSize="small"
                                                                onClick={handleLoginPopup}
                                                                disabled={props?.disabled}
                                                            />
                                                        )}

                                                        <img
                                                            className="infoIcon"
                                                            src="/assets/svg/infoIcon.svg"
                                                            onClick={handleOpenMax}
                                                        />
                                                    </>
                                                ) : isHardOfferSelected ? (
                                                    <>
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                id="place_hard_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer/'
                                                                }
                                                                type="submit"
                                                                disabled={props?.disabled}
                                                                btnSize="small"
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                id="login_to_bid"
                                                                label={
                                                                    props.type === 'hard'
                                                                        ? 'hard offer'
                                                                        : 'Make Offer'
                                                                }
                                                                disabled={props?.disabled}
                                                                onClick={handleLoginPopup}
                                                                btnSize="small"
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Button
                                                        variant="Text"
                                                        style={{
                                                            textTransform: 'none',
                                                            width: '100%',
                                                        }}
                                                        // disabled={props.disabled}
                                                        onClick={toggleHardOffer}
                                                        className="pl-0 mt-0 newBtClass"
                                                    >
                                                        {<ExpandMoreIcon />} hard offer
                                                    </Button>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                )}
                            </>
                        ) : null}
                    </>

                    <CustomDialog
                        open={toggleDialog}
                        function={changeDialogStatus}
                        className="ConfirmBidDialog"
                    >
                        {productLocation?.name ? (
                            <div className="maxOfferPickLoc">
                                <span>Pickup Location:</span>
                                <a
                                    className="get-directions-link"
                                    target="_blank"
                                    href={`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${productLocation?.place_id}`}
                                    rel="noreferrer"
                                >
                                    {productLocation?.full_address || productLocation?.name || ''}
                                </a>
                            </div>
                        ) : null}

                        {product?.asin_price && formik.values.wsprice >= 3 * product?.asin_price ? (
                            <>
                                <h5 className="biddedAmount">
                                    You are about to place a
                                    <span
                                        style={{
                                            fontSize: '21px',
                                            fontWeight: '500',
                                        }}
                                    >
                                        {' '}
                                        {currencyFormat(
                                            formik.values.wsprice == ''
                                                ? isDefaultWprice
                                                : formik.values.wsprice,
                                        )}
                                    </span>{' '}
                                    Offer, Which is three times the retail price !
                                </h5>

                                {/* <h5
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        color: 'red',
                                    }}
                                >
                                    Warning !
                                </h5> */}
                            </>
                        ) : formik.values.wsprice >=
                          (configVariables?.overbid_notification || 2) * product?.wprice ? (
                            <>
                                <h5 className="biddedAmount">
                                    {props.type == 'hard' ? 'Hard Offer:' : 'Max Offer:'}
                                    <span
                                        style={{
                                            fontSize: '21px',
                                            fontWeight: '500',
                                        }}
                                    >
                                        {currencyFormat(
                                            formik.values.wsprice == ''
                                                ? isDefaultWprice
                                                : formik.values.wsprice,
                                        )}
                                    </span>
                                </h5>
                            </>
                        ) : (
                            <h5
                                className="biddedAmount"
                                style={{
                                    fontSize: '21px',
                                    fontWeight: '500',
                                }}
                            >
                                {props.type == 'hard' ? 'Hard Offer: ' : 'Max Offer: '}

                                {currencyFormat(
                                    formik.values.wsprice == ''
                                        ? isDefaultWprice
                                        : formik.values.wsprice,
                                )}
                            </h5>
                        )}

                        <div className="actionWrapper">
                            <Button id="cancel" onClick={() => setToggleDialog(false)}>
                                {t('Cancel')}
                            </Button>
                            <PrimaryButton
                                onClick={formik.handleSubmit}
                                id="confirm_bid_submit"
                                type="button"
                                disabled={formik.isSubmitting}
                                label={t('Submit')}
                            />
                        </div>

                        <p className="DialogDisclim">
                            By submitting this offer, you are agreeing to abide by our{' '}
                            <a target="_blank" href="/terms-and-conditions">
                                Terms and Conditions.
                            </a>{' '}
                            l{' '}
                            <a target="_blank" href="/terms-and-conditions">
                                Offer Increments
                            </a>
                        </p>

                        {/* <p>
                            <b>Disclaimer</b>: By clicking Submit you agree to our terms and
                            conditions. Please be aware that you will be auto charged in case of
                            winning after the sale ends.
                        </p> */}
                    </CustomDialog>

                    <CustomDialog
                        title={t('Submit a deposit')}
                        open={toggleDialogDeposit}
                        function={changeDialogStatusDeposit}
                    >
                        <h4>{t('Deposit has to be placed before placing Offer on the product')}</h4>
                        <h5>
                            {t('Deposit amount')}: {currencyFormat(product.deposit_amount)}
                        </h5>

                        <div className="row">{Object.values(mapData(modeOfPayment))}</div>

                        <div className="actionWrapper">
                            <Button
                                id="bidding_cancel"
                                onClick={() => setToggleDialogDeposit(false)}
                            >
                                {t('Cancel')}
                            </Button>
                            <PrimaryButton
                                id="bidding_submit"
                                onClick={formikPayment.handleSubmit}
                                type="button"
                                label={t('Submit')}
                            />
                        </div>
                    </CustomDialog>

                    <CustomDialog
                        title={'No Cards Found'}
                        open={toggleDialogCard}
                        function={changeDialogStatusCard}
                    >
                        <h5>{"You don't have added any cards yet!"}</h5>
                        <h5>{'Please add a card to continue Bidding'}</h5>
                        <div className="actionWrapper" style={{ flexDirection: 'row' }}>
                            <Button id="cancel" onClick={() => setToggleDialogCard(false)}>
                                {t('Cancel')}
                            </Button>
                            <PrimaryButton
                                id="add_card"
                                label="Continue"
                                btnSize="small"
                                onClick={() =>
                                    handleRedirectInternal(history, 'payments/saved_cards')
                                }
                            />
                        </div>
                    </CustomDialog>

                    <CustomDialog
                        // title={'Mobile Number Verification'}
                        open={toggleDialogMobileVerification}
                        function={changeDialogStatusMobileVerification}
                        className="ConfirmBidDialog"
                    >
                        <h5 className="mt-3">
                            You need to verify your mobile number to proceed with your purchase or
                            offer.
                        </h5>

                        <div className="actionWrapper">
                            <Button
                                id="cancel"
                                onClick={() => setToggleDialogMobileVerification(false)}
                            >
                                {t('Cancel')}
                            </Button>
                            <PrimaryButton
                                id="add_phone"
                                label="Continue"
                                btnSize="small"
                                onClick={() =>
                                    handleRedirectInternal(history, 'my-account/personal')
                                }
                            />
                        </div>
                    </CustomDialog>

                    <Modal
                        open={isMaxOpen}
                        onClose={handleOpenMax}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box sx={pickStyle} className="boxStyle">
                            <span className="close-this-icon" onClick={handleOpenMax}>
                                &times;
                            </span>
                            <Typography id="modal-description" sx={{ mt: 2 }}>
                                <p className="mb-2">
                                    Click &#34;Max Offer&#34; to enter your max offer. Our system
                                    will automatically place incremental offers for you up to your
                                    max offer.
                                </p>
                                <p className="mb-2">
                                    Click the &#34;Hard Offer&#34; dropdown to make an offer that
                                    will become the current offer, if it is the highest placed.
                                </p>
                                <p className="learnMore mb-0">Learn more</p>
                                <Link href="/terms-and-conditions">
                                    <span className="terms">Terms & Conditions</span>
                                </Link>
                            </Typography>
                        </Box>
                    </Modal>
                </>
            ) : null}
        </>
    )
}

export default Bidding
